import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'; //, NavigationExtras
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { Http, ResponseContentType } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { HttpEvent, HttpEventType } from "@angular/common/http";

import { map } from 'rxjs/operators';

//FileSelectDirective,
//import { Subscription }   from 'rxjs';

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';
//import { CommonService } from '../providers/common.service';

@Component({
  selector: 'app-addinvoice',
  templateUrl: './addinvoice.component.html',
  styleUrls: ['./addinvoice.component.css']
})
export class AddinvoiceComponent implements OnInit {

  //subscription: Subscription;
  wdata : any = '';
  options;
  uploader: FileUploader;
  uploaderPdf: FileUploader;
  allowedMimeType = [];
  allowedMimeTypePdf = [];
  url = '';
  sequence = '';
  invoice_file_name='';
  invoice_file_name2='';
  invoice_file_name3='';
  invoice_file_name4='';
  full_image = '';
  pdf_icon = this.bp.imgUrl+'pdf_icon_new.jpg';
  mobHeight: any;
  mobWidth: any;
  file;
  uploadInProgress = false;
  uploadProgress = 0;
  hasValue = false;
  fileUploadType;
  imgPreview;
  oldPdf;
  oldImage = false;

  constructor(
    public bp: BasicProvider,
    public up: UserProvider,
    public router: Router,
    private http: Http,
    public httpClient: HttpClient,
    //private CommonService: CommonService
  ) {

    /*this.subscription = this.CommonService.warehousedata$.subscribe(
      wdata => {
        this.wdata = wdata;
        if(this.wdata.invoice_file_name){
          this.invoiceFullImage = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name;
        }
    });*/

    //Set data
    this.wdata = this.up.tempWarehouseData;

    if(this.wdata == ''){
      this.router.navigate(['mypackage']);
    }
    if(this.wdata.invoice_file_name){
      let fileNameInvoice1 = this.wdata.invoice_file_name
      var splitted = fileNameInvoice1.split("invoices");
     
      if(splitted.length>1){
        this.invoice_file_name = this.bp.AWS_S3_BUCKET_URL+'/'+this.wdata.invoice_file_name;
      } else {
       // this.invoice_file_name = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name;
       this.invoice_file_name = this.bp.AWS_S3_BUCKET_URL+'/'+this.wdata.invoice_file_name;
        this.oldImage = true;
      }
     
    }
    if(this.wdata.invoice_file_name2){
      let fileNameInvoice2 = this.wdata.invoice_file_name2
      var splitted2 = fileNameInvoice2.split("invoices");
      if(splitted2.length>1){
      this.invoice_file_name2 = this.bp.AWS_S3_BUCKET_URL+'/'+this.wdata.invoice_file_name2;
      } else {
       // this.invoice_file_name2 = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name2;
       this.invoice_file_name2 = this.bp.AWS_S3_BUCKET_URL+'/'+this.wdata.invoice_file_name2;

        this.oldImage = true;
      }

    }
    if(this.wdata.invoice_file_name3){
      let fileNameInvoice3 = this.wdata.invoice_file_name3
      var splitted3 = fileNameInvoice3.split("invoices");
      if(splitted3.length>1){
        this.invoice_file_name3 = this.bp.AWS_S3_BUCKET_URL+'/'+this.wdata.invoice_file_name3;
        } else {
        //  this.invoice_file_name3 = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name3;
        this.invoice_file_name3 = this.bp.AWS_S3_BUCKET_URL+'/'+this.wdata.invoice_file_name3;
          this.oldImage = true;
        }
    }
    if(this.wdata.invoice_file_name4){
      let fileNameInvoice4 = this.wdata.invoice_file_name4
      var splitted4 = fileNameInvoice4.split("invoices");
      if(splitted4.length>1){
        this.invoice_file_name4 = this.bp.AWS_S3_BUCKET_URL+'/'+this.wdata.invoice_file_name4;
        } else {
         // this.invoice_file_name4 = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name4;
          this.invoice_file_name4 = this.bp.AWS_S3_BUCKET_URL+'/'+this.wdata.invoice_file_name4;
          this.oldImage = true;
        }
    }


    //Upload file
    this.allowedMimeType = ['image/png', 'image/gif', 'image/jpg', 'image/jpeg'];
    this.url = this.bp.httpUrl + 'warehouse/upload_invoice';
    this.uploader = new FileUploader({url: this.url, headers: this.options,  itemAlias: 'image',
    allowedMimeType: this.allowedMimeType});
    console.log("this uploader data>>>>>>>",this.uploader);

    this.allowedMimeTypePdf = ['application/pdf'];
    this.uploaderPdf = new FileUploader({url: this.url, headers: this.options,  itemAlias: 'image',
    allowedMimeType: this.allowedMimeTypePdf});

  }

  /* downloadFile(filename) {
    let url = this.bp.httpUrl + 'warehouse/download_file';
    let body = {file_name:filename, folder:'receipts/'}
    return this.httpClient
    .post(url, body , {
      responseType : 'blob',
      headers : new HttpHeaders().append('content-type','application/json')
    })
    .subscribe(
      res => {
        saveAs(res,filename);
      }, error => {
        //console.log('download error:', JSON.stringify(error));
      }, () => {
        //console.log('Completed file download.')
      });
  } */

  downloadFile(filename) {
    let url = this.bp.httpUrl + 'warehouse/download_file';
    let body = {file_name:filename, folder:'receipts/'}
    return this.httpClient
    .post(url, body , {
      responseType : 'blob',
      headers : new HttpHeaders().append('content-type','application/json')
    })
    .subscribe(
      res => {
        var file = new Blob([res], { type: 'application/pdf' })
        const link = document.createElement('a');
        link.href = URL.createObjectURL(file);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(link.href), 7000);
       }, error => {
        //console.log('download error:', JSON.stringify(error));
      }, () => {
        //console.log('Completed file download.')
      });
  }
  
  downloadInvoiceFile(filename) {
    let url = filename;
    //url  = "https://dashexpress.s3.us-east-2.amazonaws.com/"+filename;
    return this.httpClient
    .get(url, {
      responseType : 'blob',
      headers : new HttpHeaders().append('content-type','application/pdf')
    })
    .subscribe(
      res => {
        saveAs(res,"invoice.pdf");
      }, error => {
        //console.log('download error:', JSON.stringify(error));
      }, () => {
        //console.log('Completed file download.')
      });
    
  }

  onchangeFile(event,sequence) {
    let allowFileType = ["jpg", "png", "jpeg","pdf"];
    let selectedFileType = event.target.files.length
      ? event.target.files[0].name.split(".").pop().toLowerCase()
      : "";
    if (!selectedFileType) return;

    if (!allowFileType.includes(selectedFileType)) {
      this.bp.show_toast(
        "Error",
        "Please select correct file of allow format. Allowled format are jpg, png, jpeg"
      );
      return;
    }
    let data = { location: "invoices", type: "IMAGE" };
    if(selectedFileType=='pdf'){
      data = { location: "invoices", type: "DOCUMENT.PDF" };
    }
    let api = `warehouse/upload_files`;
    const [file] = event.target.files;
    this.file = file;
    this.bp.hitApi(api, "GET", data, true, true).subscribe((success) => {
      this.hasValue = true;
      if (success.type == true) {
        this.bp.upload(success.data[0].url, file, null, true)
          .subscribe((event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this.uploadInProgress = true;
                break;
              case HttpEventType.UploadProgress:
                this.uploadProgress = Math.round(
                  (100 * event.loaded) / event.total
                );
                break;
              case HttpEventType.Response:
                this.resetUploadProgress();
                this.file = undefined;
                this.hasValue = true;
                let invoiceName = success.data[0].location;
                this.imgPreview = success.data[0].preview;
                let warehouse_id = this.wdata.id;

                api = `warehouse/upload_invoice`;
                this.bp
                  .hitApi(api, "POST", { invoiceName,warehouse_id,sequence }, true, true)
                  .subscribe((success) => {
                    console.log("this image");
                    if (success.type == true) {
                      if(sequence==1){
                        this.invoice_file_name = this.bp.AWS_S3_BUCKET_URL+'/'+invoiceName;
                        this.bp.getInvoice(this.invoice_file_name, 'invoice');
                      }
                      if(sequence==2){
                        console.log("this image upload2");
                        this.invoice_file_name2 = this.bp.AWS_S3_BUCKET_URL+'/'+invoiceName;
                        this.bp.getInvoice(this.invoice_file_name2, 'invoice');
                      }
                      if(sequence==3){
                        this.invoice_file_name3 = this.bp.AWS_S3_BUCKET_URL+'/'+invoiceName;
                        this.bp.getInvoice(this.wdata.invoice_file_name3, 'invoice');
                      }
                      if(sequence==4){
                        this.invoice_file_name4 = this.bp.AWS_S3_BUCKET_URL+'/'+invoiceName;
                        this.bp.getInvoice(this.invoice_file_name4, 'invoice');
                      }
                      //this.up.invoice_file+sequence = invoiceName;
                    //  this.up.updateProfileImage(this.up.profile_image);
                      this.bp.show_toast("Success", success.message);
                    }
                  });
            }
          });
      } else {
        this.bp.show_toast("Error", success.message);
      }
    });
  }

  setVal(sequence){
    if (sequence < 4 && this.invoice_file_name4!=='' ) {
      this.bp.show_toast('Error','Either you can add a pdf invoice or images of invoice.');
      return false;
    }

    if (sequence == 4 && (this.invoice_file_name!=='' || this.invoice_file_name2!=='' || this.invoice_file_name3!=='') ) {
      this.bp.show_toast('Error','Either you can add a pdf invoice or images of invoice.');
      return false;
    }


    if (this.wdata.is_tax_calculated == 1 || this.wdata.invoice_by_admin == 1) {
      this.bp.show_toast('Error','You can\'t Upload/Delete invoice, please contact to Administrator.');
      return false;
    } else {
      this.sequence = sequence;
    }
  }

  viewImage(sequence){
    // Get the modal
    var modal = document.getElementById('w-image-modal');
    let image_src = '';
    if (sequence == '2') {
      image_src = this.invoice_file_name2;
    } else if(sequence == '3') {
      image_src = this.invoice_file_name3;
    } else if(sequence == '4') {
      image_src = this.invoice_file_name4;
      window.open(image_src,
        'Pdf Invoice',
        'toolbar=no,scrollbars=yes,resizable=no,top=100,left=500,width=600,height=400,location=0');
        return;
    } else {
      image_src = this.invoice_file_name;
    }

    // Get the image and insert it inside the modal - use its "alt" text as a caption
    modal.style.display = "block";
    this.full_image = image_src;
  }

  closeImage(){
    var modal = document.getElementById('w-image-modal');
    modal.style.display = "none";
  }

  removeImage(sequence,invoiceName,e){
    e.stopPropagation();
    if (this.wdata.is_tax_calculated == 1 || this.wdata.invoice_by_admin == 1) {
      this.bp.show_toast('Error','You can\'t Upload/Delete invoice, please contact to Administrator.');
      return false;
    }

    if(confirm("Do you want to delete this invoice?")) {
      this.bp.hitApi('warehouse/remove_invoice', 'POST', {"warehouse_id":this.wdata.id,"invoiceName":invoiceName, "sequence":sequence}, true, true)
      .subscribe(
        (success) => {
          if( success.type == true ){

            if (sequence == '2') {
              this.wdata.invoice_file_name2 = '';
              this.invoice_file_name2 = '';
            } else if(sequence == '3') {
              this.wdata.invoice_file_name3 = '';
              this.invoice_file_name3 = '';
            } else if(sequence == '4') {
              this.wdata.invoice_file_name4 = '';
              this.invoice_file_name4 = '';
            } else {
              this.wdata.invoice_file_name = '';
              this.invoice_file_name = '';
            }

            this.bp.show_toast('Success',success.message);
          }else{
            this.bp.show_toast('Error',success.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }


  }

  ngOnInit() {

    this.uploader.onAfterAddingFile = (file) => {

      var uo: FileUploaderOptions = {};
      uo.headers = [{ name: 'sid', value : this.up.sid }, { name: 'warehouse_id', value : this.wdata.id }, { name: 'sequence', value : this.sequence } ]
      this.uploader.setOptions(uo);

      file.withCredentials = false;
      this.uploader.uploadAll();

    };

    this.uploader.onCompleteItem = (item: any, success: any, status: any, headers: any) => {
      let result = JSON.parse(success);
      if(result.type){
        if (this.sequence == '2') {
          this.wdata.invoice_file_name2 = result.data.image_name;
          this.invoice_file_name2 = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name2;
        } else if(this.sequence == '3') {
          this.wdata.invoice_file_name3 = result.data.image_name;
          this.invoice_file_name3 = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name3;
        } else {
          this.wdata.invoice_file_name = result.data.image_name;
          this.invoice_file_name = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name;
        }
        this.bp.show_toast('Success',result.message);
      } else {
        this.bp.show_toast('Error',result.message);
      }
    };

    this.uploader.onWhenAddingFileFailed = (item, filter, options) => {
      this.bp.show_toast('Error','Only jpeg, png, gif images are allowed.');
    };


    // Function for pdf upload
    this.uploaderPdf.onAfterAddingFile = (file) => {
      var uo: FileUploaderOptions = {};
      uo.headers = [{ name: 'sid', value : this.up.sid }, { name: 'warehouse_id', value : this.wdata.id }, { name: 'sequence', value : this.sequence } ]
      this.uploaderPdf.setOptions(uo);

      file.withCredentials = false;
      this.uploaderPdf.uploadAll();
    };

    this.uploaderPdf.onCompleteItem = (item: any, success: any, status: any, headers: any) => {
      let result = JSON.parse(success);
      if(result.type){
        this.wdata.invoice_file_name4 = result.data.image_name;
        this.invoice_file_name4 = this.bp.imgUrl+'invoices/'+this.wdata.invoice_file_name4;
        this.bp.show_toast('Success',result.message);
      } else {
        this.bp.show_toast('Error',result.message);
      }
    };

    this.uploaderPdf.onWhenAddingFileFailed = (item, filter, options) => {
      this.bp.show_toast('Error','Only pdf is allowed.');
    };
  }

  private resetUploadProgress() {
    this.uploadInProgress = false;
    this.uploadProgress = 0;
  }

  getExtensionOfFile(filename){
    if(filename){
      let ext = filename.split(".").pop().toLowerCase()
      if(ext=='pdf'){
        return false
      } else {
        return true;
      }
    } else {
      return true;
    }
   
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    //this.subscription.unsubscribe();
  }


}



// WEBPACK FOOTER //
// ./src/app/addinvoice/addinvoice.component.ts